import Main from './components/Main/Main';
import { AppStateProvider } from './context/AppStateProvider/AppStateProvider';
import { ThemeProvider } from '@mui/material/styles';
import { ErrorBoundary, type FallbackProps } from 'react-error-boundary';
import type { EmotionCache } from '@emotion/react';

type AppProps = {
    emotionCache: EmotionCache;
    theme: any; // your MUI theme
};

function fallbackRender({ error, resetErrorBoundary }: FallbackProps) {
    return (
        <div role='alert'>
            <p>Something went wrong:</p>
            <pre style={{ color: 'red' }}>{error instanceof Error ? error.message : 'Unknown error'}</pre>
            <button onClick={resetErrorBoundary}>Try again</button>
        </div>
    );
}

function App({ theme }: AppProps) {
    return (
        <ErrorBoundary fallbackRender={fallbackRender}>
            <ThemeProvider theme={theme}>
                <AppStateProvider>
                    <Main />
                </AppStateProvider>
            </ThemeProvider>
        </ErrorBoundary>
    );
}

export default App;
